import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import {
  brandFieldBaseClassName,
  surfaceFieldBaseClassName,
} from "@/components/ui/field-styles"
import { cn } from "@/lib/utils"

const textareaVariants = cva(
  "flex w-full border outline-none transition-[color,box-shadow] disabled:cursor-not-allowed disabled:opacity-50 focus-visible:ring-[3px]",
  {
    variants: {
      variant: {
        default:
          "border-input placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 field-sizing-content min-h-16 rounded-lg bg-transparent px-3 py-2 text-base shadow-xs md:text-sm",
        surface:
          "field-sizing-content min-h-16 resize-none px-3 py-2 aria-invalid:border-destructive aria-invalid:ring-destructive/20 " +
          surfaceFieldBaseClassName,
        brand:
          "field-sizing-content min-h-16 px-3 py-2 focus-visible:ring-[3px] resize-none aria-invalid:border-destructive aria-invalid:ring-destructive/20 " +
          brandFieldBaseClassName,
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Textarea({
  className,
  variant,
  ...props
}: React.ComponentProps<"textarea"> &
  VariantProps<typeof textareaVariants>) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(textareaVariants({ variant }), className)}
      {...props}
    />
  )
}

export { Textarea }
